import { SaleOrderLine } from './sale-order-line';
import { SaleOffer } from './sale-offer';


export const STATUS_PENDING = 1;
export const STATUS_IN_PROGRESS = 2;
export const STATUS_FINISHED = 3;
export const VAT_VALUE = 21;
export const IS_DEPOSIT = 1;
export const NOT_DEPOSIT = 0;

export class SaleOrder {
  constructor(
    public hash?: string,
    public orderDate?: number,
    public customerHash?: string,
    public customerBusinessName?: string,
    public customerTradeName?: string,
    public traderHash?: string,
    public traderFirstName?: string,
    public traderLastName?: string,
    public orderNumber?: number,
    public observations?: string,
    public additionalData?: string,
    public internalObservations?: string,
    public paymentMethodHash?: string,
    public paymentMethodDescription?: string,
    public subTotalAmount?: number,
    public vat?: number,
    public totalVat?: number,
    public totalAmount?: number,
    public status?: number,
    public isPendingStepFinished?: boolean,
    public isInvoiceStepFinished?: boolean,
    public isDepartureStepFinished?: boolean,
    public isPreparationStepFinished?: boolean,
    public isPostageStepFinished?: boolean,
    public isControlDocumentStepFinished?: boolean,
    public sentByEmailDate?: number,
    public signedByCustomerDate?: number,
    public personWhoIsGoingToSign?: string,
    public saleOrderDepartureHash?: string,
    public saleOrderPreparationHash?: string,
    public saleOrderBearingHash?: string,
    public saleOrderControlDocumentHash?: string,
    public saleOrderLines?: SaleOrderLine[],
    public isDeposit?: boolean,
    public saleOrderKeyCode?: string,
    public offer?: SaleOffer
  ) { }

  get traderFullName() {
    return `${ this.traderFirstName } ${ this.traderLastName }`;
  }

  get isStatusPending() {
    return this.status === STATUS_PENDING;
  }

  get isStatusInProgress() {
    return this.status === STATUS_IN_PROGRESS;
  }

  get isStatusFinished() {
    return this.status === STATUS_FINISHED;
  }

  clone() {
    return new SaleOrder(
      this.hash,
      this.orderDate,
      this.customerHash,
      this.customerBusinessName,
      this.customerTradeName,
      this.traderHash,
      this.traderFirstName,
      this.traderLastName,
      this.orderNumber,
      this.observations,
      this.additionalData,
      this.internalObservations,
      this.paymentMethodHash,
      this.paymentMethodDescription,
      this.subTotalAmount,
      this.vat,
      this.totalVat,
      this.totalAmount,
      this.status,
      this.isPendingStepFinished,
      this.isInvoiceStepFinished,
      this.isDepartureStepFinished,
      this.isPreparationStepFinished,
      this.isPostageStepFinished,
      this.isControlDocumentStepFinished,
      this.sentByEmailDate,
      this.signedByCustomerDate,
      this.personWhoIsGoingToSign,
      this.saleOrderDepartureHash,
      this.saleOrderPreparationHash,
      this.saleOrderBearingHash,
      this.saleOrderControlDocumentHash,
      this.saleOrderLines,
      this.isDeposit,
      this.saleOrderKeyCode,
      this.offer
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-order.ts